import { configureStore, combineSlices, createAction } from '@reduxjs/toolkit';
import toastsReducer from "@Components/Common/Toasts/toasts.slice";
import regionReducer from "@Components/Common/Region/region.slice";

export const resetApp = createAction('global/reset');

// Create a root reducer using combineSlices
export const appReducer = combineSlices({
  // Static core reducer
  core: (state = { initialized: true, version: '1.0.0' }) => state,
  toasts: toastsReducer,
  region: regionReducer,
}).withLazyLoadedSlices<any>();

export const rootReducer = (state: any, action: any) => {
  if (action.type === resetApp.type) {
    state = undefined;
  }
  return appReducer(state, action);
};

export function configureAppStore() {
  const store = configureStore({
    reducer: rootReducer,
  });
  
  // Attach the rootReducer to the store instance so it can be accessed 
  // by remote MFEs for dynamic slice injection.
  (store as any).asyncReducer = appReducer;

  return store;
}

export const store = configureAppStore();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
